.container {
  background-color: var(--colors-grays-white);
  inset: 0;
  max-height: 100%;
  overflow: auto;
  position: fixed;
  top: 100%;
  transition:
    top 0.5s ease,
    opacity 0.5s ease;
  width: 100%;
  z-index: var(--z-search-suggestions);
}

.container::-webkit-scrollbar {
  display: none;
}

.dismissIcon {
  flex: 0 0 auto;
}

.searchText {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.searchFieldBox svg > path {
  fill: var(--colors-text-main);
}

.searchFieldBox input:placeholder-shown {
  text-overflow: ellipsis;
}

@media all and (width > 1076px) {
  .container {
    display: none;
  }
}
